var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg090Binoculars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.789,201.508c-0.922-0.875-1.941-1.675-3.054-2.383c-41.686-26.519-101.536-58.058-134.74-75.114 C301.721,102.833,280.56,88,256,88s-45.721,14.833-54.995,36.011c-33.204,17.056-93.054,48.595-134.74,75.114 c-1.113,0.708-2.132,1.508-3.054,2.383C25.661,221.277,0,260.698,0,306c0,65.065,52.935,118,118,118s118-52.935,118-118 c0-11.028,8.972-20,20-20s20,8.972,20,20c0,65.065,52.935,118,118,118c25.337,0,49.491-7.914,69.852-22.888 c8.898-6.544,10.807-19.063,4.263-27.961c-6.544-8.899-19.062-10.807-27.961-4.264C426.71,378.774,410.75,384,394,384 c-43.009,0-78-34.99-78-78s34.991-78,78-78c43.009,0,78,34.99,78,78c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20 C512,260.698,486.339,221.277,448.789,201.508z M256,128c11.028,0,20,8.972,20,20s-8.972,20-20,20s-20-8.972-20-20 S244.972,128,256,128z M118,384c-43.009,0-78-34.99-78-78s34.991-78,78-78c43.009,0,78,34.99,78,78S161.009,384,118,384z  M287.595,255.011C278.413,249.301,267.585,246,256,246c-11.585,0-22.413,3.301-31.595,9.011 c-13.846-28.777-39.029-51.111-69.721-61.174c16.055-8.814,31.731-17.147,45.328-24.258C208.696,192.033,230.519,208,256,208 s47.304-15.967,55.987-38.421c13.598,7.111,29.273,15.444,45.328,24.258C326.624,203.899,301.441,226.233,287.595,255.011z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg090Binoculars);
export default __webpack_public_path__ + "static/media/090-binoculars.9193cc622a8b4d6a64fff9047748cee2.svg";
export { ForwardRef as ReactComponent };